export default __webpack_public_path__ + "static/media/rectangle.42acac2f.svg";